// Static print mode: when the page is loaded with ?print=1, scroll-reveal
// animations and count-ups render in their final visible state so the page
// can be captured cleanly as a printable PDF (no blank sections / $0 counters).
export const isPrintMode =
  typeof window !== "undefined" &&
  new URLSearchParams(window.location.search).get("print") === "1";
